// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview__container {
  display: flex;
}

.preview__row{
  margin: 0;
  display: flex;
  width: 33%;
}

.preview__wrapper {
  margin-right: 1rem;
  text-align: left;
  width: 100%;
}

.preview__wrapper__title {
  margin: 1rem 0 1rem 0;
  height: 35px;
  font-size: var(--subheader);
}

.large {
  height: 70px;
  overflow: auto;
  word-break: break-word;
}

.shadow-box {
  box-shadow: 0px 0px 3px 0px grey;
}

.disabled {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/createTab/Preview/Preview.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".preview__container {\n  display: flex;\n}\n\n.preview__row{\n  margin: 0;\n  display: flex;\n  width: 33%;\n}\n\n.preview__wrapper {\n  margin-right: 1rem;\n  text-align: left;\n  width: 100%;\n}\n\n.preview__wrapper__title {\n  margin: 1rem 0 1rem 0;\n  height: 35px;\n  font-size: var(--subheader);\n}\n\n.large {\n  height: 70px;\n  overflow: auto;\n  word-break: break-word;\n}\n\n.shadow-box {\n  box-shadow: 0px 0px 3px 0px grey;\n}\n\n.disabled {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
